import "./App.css";
import "./index.css";
import AppRoutes from "./navigation/Routes";
import { BrowserRouter as Router } from "react-router-dom";
import { RecoilRoot } from "recoil";
import RecoilNexus from "recoil-nexus";
import config from "./config";
import ErrorBoundary from "./components/ErrorBoundary";
import { WebSocketProvider } from "./features/webPush/webSocketContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { FeatureFlagProvider } from "./contexts/featureFlagProvider";
import { LoaderProvider } from "./contexts/loaderProvider";
import { DarkModeProvider } from "./contexts/darkModeProvider";
import { Toaster } from "./components/ui/sonner";
import { UploadProgressProvider } from "./contexts/uploadProgressContext";
import UploadProgressPanel from "./components/loaders/UploadProgressPanel";

const stripePromise = loadStripe(config.stripe.STRIPE_KEY);
console.log(config.BuildVersion);

function App() {
  return (
    <RecoilRoot>
      <UploadProgressProvider>
        <DarkModeProvider>
          <Router>
            <WebSocketProvider>
              <FeatureFlagProvider>
                <LoaderProvider>
                  <Elements stripe={stripePromise}>
                    <RecoilNexus />
                    <ErrorBoundary>
                      <AppRoutes />
                      <Toaster />
                      <UploadProgressPanel />
                    </ErrorBoundary>
                  </Elements>
                </LoaderProvider>
              </FeatureFlagProvider>
            </WebSocketProvider>
          </Router>
        </DarkModeProvider>
      </UploadProgressProvider>
    </RecoilRoot>
  );
}

export default App;
